// Shared PM-Cal sample data (converted from public/js/app.js)

export const sampleAssets = [
  {
    id: "AST001",
    name: "Digital Pressure Gauge PG-001",
    type: "Pressure Measurement",
    location: "Lab A - Clean Room",
    status: "active",
    calibrationStatus: "valid",
    manufacturer: "Fluke Corporation",
    model: "PG-500",
    serialNumber: "FLK-PG-001-2023",
    range: "0-500 psi",
    accuracy: "±0.25%",
    criticality: "high",
    department: "Quality Control",
    responsiblePerson: "John Smith",
  },
  {
    id: "AST002",
    name: "RTD Temperature Sensor TS-002",
    type: "Temperature Measurement",
    location: "Lab B - Environmental Chamber",
    status: "active",
    calibrationStatus: "due-soon",
    manufacturer: "Omega Engineering",
    model: "RTD-PT100",
    serialNumber: "OMG-TS-002-2024",
    range: "-200°C to 850°C",
    accuracy: "±0.3°C",
    criticality: "high",
    department: "Environmental Testing",
    responsiblePerson: "Sarah Johnson",
  },
  {
    id: "AST003",
    name: "Ultrasonic Flow Meter FM-003",
    type: "Flow Measurement",
    location: "Lab C - Flow Testing",
    status: "active",
    calibrationStatus: "valid",
    manufacturer: "Siemens",
    model: "SITRANS FUS1010",
    serialNumber: "SIE-FM-003-2024",
    range: "0-50 m/s",
    accuracy: "±1%",
    criticality: "medium",
    department: "Process Engineering",
    responsiblePerson: "Mike Wilson",
  },
  {
    id: "AST004",
    name: "Digital pH Meter PH-004",
    type: "pH Measurement",
    location: "Lab A - Chemical Analysis",
    status: "active",
    calibrationStatus: "expired",
    manufacturer: "Hanna Instruments",
    model: "HI-2020",
    serialNumber: "HAN-PH-004-2023",
    range: "0-14 pH",
    accuracy: "±0.01 pH",
    criticality: "critical",
    department: "Chemical Analysis",
    responsiblePerson: "Emily Davis",
  },
  {
    id: "AST005",
    name: "Precision Analytical Balance SC-005",
    type: "Weight Measurement",
    location: "Lab D - Analytical Room",
    status: "active",
    calibrationStatus: "due-soon",
    manufacturer: "Mettler Toledo",
    model: "XPE205",
    serialNumber: "MET-SC-005-2024",
    range: "0-220g",
    accuracy: "±0.01mg",
    criticality: "critical",
    department: "Analytical Chemistry",
    responsiblePerson: "David Brown",
  },
  {
    id: "AST006",
    name: "Infrared Thermometer IR-006",
    type: "Temperature Measurement",
    location: "Lab B - Quality Control",
    status: "active",
    calibrationStatus: "valid",
    manufacturer: "Raytek",
    model: "ST60+",
    serialNumber: "RAY-IR-006-2023",
    range: "-32°C to 600°C",
    accuracy: "±1.5°C",
    criticality: "low",
    department: "Quality Control",
    responsiblePerson: "Lisa Garcia",
  },
  {
    id: "AST007",
    name: "Differential Pressure Transmitter DP-007",
    type: "Pressure Measurement",
    location: "Lab C - Process Control",
    status: "active",
    calibrationStatus: "due-soon",
    manufacturer: "Rosemount",
    model: "3051CD",
    serialNumber: "ROS-DP-007-2024",
    range: "0-100 kPa",
    accuracy: "±0.075%",
    criticality: "high",
    department: "Process Engineering",
    responsiblePerson: "Robert Martinez",
  },
  {
    id: "AST008",
    name: "Conductivity Meter CD-008",
    type: "Conductivity Measurement",
    location: "Lab A - Water Quality",
    status: "active",
    calibrationStatus: "valid",
    manufacturer: "Hach",
    model: "HQ40d",
    serialNumber: "HAC-CD-008-2023",
    range: "0-200 mS/cm",
    accuracy: "±1%",
    criticality: "medium",
    department: "Environmental Testing",
    responsiblePerson: "Jennifer Lee",
  },
  {
    id: "AST009",
    name: "Gas Chromatograph GC-009",
    type: "Chemical Analysis",
    location: "Lab E - Analytical Lab",
    status: "active",
    calibrationStatus: "valid",
    manufacturer: "Agilent Technologies",
    model: "7890B",
    serialNumber: "AGI-GC-009-2024",
    range: "C1-C40",
    accuracy: "±2%",
    criticality: "critical",
    department: "Analytical Chemistry",
    responsiblePerson: "Thomas Anderson",
  },
  {
    id: "AST010",
    name: "Spectrophotometer SP-010",
    type: "Optical Measurement",
    location: "Lab F - Spectroscopy",
    status: "active",
    calibrationStatus: "valid",
    manufacturer: "PerkinElmer",
    model: "Lambda 365",
    serialNumber: "PKE-SP-010-2023",
    range: "190-900 nm",
    accuracy: "±0.3 nm",
    criticality: "high",
    department: "Research & Development",
    responsiblePerson: "Maria Rodriguez",
  },
];

export const sampleTools = [
  {
    id: "TL001",
    name: "Precision Digital Multimeter DMM-001",
    type: "Electrical",
    manufacturer: "Keysight",
    model: "34465A",
    accuracy: "±0.0035%",
  },
  {
    id: "TL002",
    name: "Pneumatic Pressure Calibrator PC-002",
    type: "Pressure",
    manufacturer: "Druck",
    model: "DPI611",
    accuracy: "±0.025%",
  },
  {
    id: "TL003",
    name: "Dry Block Temperature Calibrator TC-003",
    type: "Temperature",
    manufacturer: "Hart Scientific",
    model: "9142",
    accuracy: "±0.25°C",
  },
  {
    id: "TL004",
    name: "Hydraulic Dead Weight Tester DWT-004",
    type: "Pressure",
    manufacturer: "Ametek",
    model: "T-950",
    accuracy: "±0.015%",
  },
  {
    id: "TL005",
    name: "Platinum Resistance Reference Thermometer RT-005",
    type: "Temperature",
    manufacturer: "Hart Scientific",
    model: "5628",
    accuracy: "±0.003°C",
  },
  {
    id: "TL006",
    name: "pH Buffer Solution Set pH-006",
    type: "pH Calibration",
    manufacturer: "NIST",
    model: "SRM-185",
    accuracy: "±0.01 pH",
  },
  {
    id: "TL007",
    name: "Certified Mass Set MS-007",
    type: "Weight",
    manufacturer: "Troemner",
    model: "UltraClass",
    accuracy: "±0.05mg",
  },
  {
    id: "TL008",
    name: "Conductivity Standard Solution CS-008",
    type: "Conductivity",
    manufacturer: "Oakton",
    model: "WD-35607",
    accuracy: "±1%",
  },
  {
    id: "TL009",
    name: "Oscilloscope Signal Generator OSC-009",
    type: "Electrical",
    manufacturer: "Tektronix",
    model: "MSO64",
    accuracy: "±1%",
  },
  {
    id: "TL010",
    name: "Force Gauge Calibrator FC-010",
    type: "Mechanical",
    manufacturer: "Mark-10",
    model: "BG-2000",
    accuracy: "±0.1%",
  },
];

const eamWorkOrders = [
  "WO-2026-4501",
  "WO-2026-4502",
  "WO-2026-4503",
  "WO-2026-4488",
  "WO-2026-4504",
  "WO-2026-4510",
  "WO-2026-4505",
  "WO-2026-4412",
  "WO-2026-4425",
  "WO-2026-4512",
  "WO-2026-4388",
  "WO-2025-3901",
  "WO-2026-4401",
];
const eamPMPlans = [
  "PMPLAN-081",
  "PMPLAN-082",
  "PMPLAN-083",
  "PMPLAN-079",
  "PMPLAN-085",
  "PMPLAN-091",
  "PMPLAN-086",
  "PMPLAN-072",
  "PMPLAN-073",
  "PMPLAN-093",
  "PMPLAN-083",
  "PMPLAN-085",
  "PMPLAN-094",
];

const basePMCals = [
  {
    id: "PMCAL-2026-0001",
    assetId: "AST001",
    assetName: "Digital Pressure Gauge PG-001",
    toolId: "TL002",
    toolName: "Pneumatic Pressure Calibrator PC-002",
    plannedStartDate: "2026-04-15",
    plannedDueDate: "2026-04-17",
    frequency: "semi-annually",
    description:
      "Semi-annual calibration of pressure gauge in clean room environment",
    status: "pending",
    priority: "high",
    technician: "John Smith",
    approver: "Sarah Johnson",
    createdBy: "Admin User",
    createdAt: "2026-04-01T10:30:00.000Z",
    lastModified: "2026-04-01T10:30:00.000Z",
    estimatedDuration: "2 hours",
    requirements: "Clean room protocol, ESD protection",
    riskAssessment: "Low risk - routine calibration",
  },
  {
    id: "PMCAL-2026-0002",
    assetId: "AST002",
    assetName: "RTD Temperature Sensor TS-002",
    toolId: "TL003",
    toolName: "Dry Block Temperature Calibrator TC-003",
    plannedStartDate: "2026-04-10",
    plannedDueDate: "2026-04-12",
    frequency: "semi-annually",
    description: "Semi-annual calibration of RTD sensor – due this week",
    status: "in-progress",
    priority: "high",
    technician: "Mike Wilson",
    approver: "Emily Davis",
    approvedBy: "Emily Davis",
    approvedAt: "2026-04-09T16:00:00.000Z",
    createdBy: "Admin User",
    createdAt: "2026-03-28T14:20:00.000Z",
    lastModified: "2026-04-10T09:00:00.000Z",
    estimatedDuration: "4 hours",
    requirements: "Environmental chamber isolation required",
    riskAssessment: "Medium risk - critical process sensor",
    actualStartDate: "2026-04-10T09:00:00.000Z",
    progress: 60,
    measurements: [
      {
        point: "-50°C",
        reference: "-50.00°C",
        measured: "-49.97°C",
        error: "0.03°C",
        tolerance: "±0.3°C",
        result: "PASS",
      },
      {
        point: "0°C",
        reference: "0.00°C",
        measured: "0.02°C",
        error: "-0.02°C",
        tolerance: "±0.3°C",
        result: "PASS",
      },
    ],
  },
  {
    id: "PMCAL-2026-0003",
    assetId: "AST003",
    assetName: "Analytical Balance AB-003",
    toolId: "TL001",
    toolName: "Digital Multimeter DM-001",
    plannedStartDate: "2026-04-20",
    plannedDueDate: "2026-04-22",
    frequency: "quarterly",
    description:
      "Q2 calibration of analytical balance for mass measurement accuracy",
    status: "pending",
    priority: "critical",
    technician: "Sarah Johnson",
    approver: "Maria Rodriguez",
    createdBy: "Admin User",
    createdAt: "2026-04-02T08:00:00.000Z",
    lastModified: "2026-04-02T08:00:00.000Z",
    estimatedDuration: "3 hours",
    requirements: "NIST traceable weights required",
    riskAssessment: "High risk - critical weighing instrument",
  },
  {
    id: "PMCAL-2026-0004",
    assetId: "AST004",
    assetName: "pH Meter PM-004",
    toolId: "TL005",
    toolName: "pH Reference Standard Set",
    plannedStartDate: "2026-04-08",
    plannedDueDate: "2026-04-09",
    frequency: "monthly",
    description: "Monthly pH meter calibration - OVERDUE since Apr 1",
    status: "overdue",
    priority: "high",
    technician: "Lisa Chen",
    approver: "Emily Davis",
    createdBy: "Admin User",
    createdAt: "2026-03-20T11:00:00.000Z",
    lastModified: "2026-04-07T08:00:00.000Z",
    estimatedDuration: "1 hour",
    requirements: "Buffer solutions pH 4.0, 7.0, 10.0",
    riskAssessment: "High risk - overdue, process quality impact",
  },
  {
    id: "PMCAL-2026-0005",
    assetId: "AST005",
    assetName: "Viscosity Meter VM-005",
    toolId: "TL006",
    toolName: "Viscosity Reference Standard VS-006",
    plannedStartDate: "2026-04-14",
    plannedDueDate: "2026-04-15",
    frequency: "semi-annually",
    description: "Semi-annual viscosity meter calibration - in progress",
    status: "in-progress",
    priority: "high",
    technician: "Tom Baker",
    approver: "Sarah Johnson",
    approvedBy: "Sarah Johnson",
    approvedAt: "2026-04-13T08:30:00.000Z",
    createdBy: "Admin User",
    createdAt: "2026-04-01T13:00:00.000Z",
    lastModified: "2026-04-13T09:00:00.000Z",
    estimatedDuration: "2 hours",
    requirements: "Certified viscosity standards, temperature-controlled bath",
    riskAssessment: "Medium risk - production quality monitoring",
    actualStartDate: "2026-04-14T09:00:00.000Z",
    progress: 30,
  },
  {
    id: "PMCAL-2026-0006",
    assetId: "AST006",
    assetName: "Torque Wrench TW-006",
    toolId: "TL007",
    toolName: "Torque Calibration Bench TC-007",
    plannedStartDate: "2026-05-01",
    plannedDueDate: "2026-05-02",
    frequency: "annually",
    description: "Annual torque wrench calibration per ISO 6789",
    status: "pending",
    priority: "medium",
    technician: "Frank Rivera",
    approver: "Robert Martinez",
    createdBy: "Admin User",
    createdAt: "2026-04-03T10:00:00.000Z",
    lastModified: "2026-04-03T10:00:00.000Z",
    estimatedDuration: "1.5 hours",
    requirements: "ISO 6789 compliance, calibration certificate required",
    riskAssessment: "Low risk - preventive maintenance",
  },
  {
    id: "PMCAL-2026-0007",
    assetId: "AST007",
    assetName: "Flow Meter FM-007",
    toolId: "TL008",
    toolName: "Flow Calibration Rig FCR-008",
    plannedStartDate: "2026-04-08",
    plannedDueDate: "2026-04-10",
    frequency: "semi-annually",
    description: "Semi-annual flow meter calibration - in progress",
    status: "in-progress",
    priority: "high",
    technician: "Alice Thompson",
    approver: "Emily Davis",
    approvedBy: "Emily Davis",
    approvedAt: "2026-04-07T15:00:00.000Z",
    createdBy: "Admin User",
    createdAt: "2026-04-03T14:00:00.000Z",
    lastModified: "2026-04-07T15:00:00.000Z",
    estimatedDuration: "4 hours",
    requirements: "Process fluid sample, pressure isolation",
    riskAssessment: "Medium risk - flow measurement accuracy",
    actualStartDate: "2026-04-08T08:00:00.000Z",
    progress: 45,
  },
  {
    id: "PMCAL-2026-0008",
    assetId: "AST001",
    assetName: "Digital Pressure Gauge PG-001",
    toolId: "TL002",
    toolName: "Pneumatic Pressure Calibrator PC-002",
    plannedStartDate: "2026-01-15",
    plannedDueDate: "2026-01-16",
    frequency: "semi-annually",
    description: "Q1 2026 calibration - completed successfully",
    status: "completed",
    priority: "high",
    technician: "John Smith",
    approver: "Sarah Johnson",
    createdBy: "Admin User",
    createdAt: "2026-01-05T09:00:00.000Z",
    lastModified: "2026-01-16T16:30:00.000Z",
    actualStartDate: "2026-01-15T09:00:00.000Z",
    actualEndDate: "2026-01-16T11:30:00.000Z",
    completedAt: "2026-01-16T11:30:00.000Z",
    approvedBy: "Sarah Johnson",
    approvedAt: "2026-01-17T10:00:00.000Z",
    result: "PASS",
    certificateNumber: "CAL-2026-0081",
    nextCalibrationDate: "2026-07-15",
    calibrationDate: "2026-01-15",
    calibrationType: "internal",
    calibratedBy: "John Smith",
    calibrationNotes:
      "Calibration performed per SOP-CAL-001. All pressure points within tolerance. Zero offset corrected. Span adjustment within acceptable range.",
    measurements: [
      {
        point: "0 psi",
        reference: "0.00 psi",
        measured: "0.01 psi",
        error: "0.01 psi",
        tolerance: "±0.05 psi",
        result: "PASS",
      },
      {
        point: "25 psi",
        reference: "25.00 psi",
        measured: "25.02 psi",
        error: "0.02 psi",
        tolerance: "±0.10 psi",
        result: "PASS",
      },
      {
        point: "50 psi",
        reference: "50.00 psi",
        measured: "49.98 psi",
        error: "0.02 psi",
        tolerance: "±0.10 psi",
        result: "PASS",
      },
      {
        point: "100 psi",
        reference: "100.00 psi",
        measured: "100.03 psi",
        error: "0.03 psi",
        tolerance: "±0.10 psi",
        result: "PASS",
      },
    ],
    certificates: [
      {
        number: "CAL-2026-0081",
        issuedBy: "Internal Calibration Lab",
        issuedAt: "2026-01-17",
        validUntil: "2026-07-15",
        traceable: "NIST",
      },
    ],
  },
  {
    id: "PMCAL-2026-0009",
    assetId: "AST002",
    assetName: "RTD Temperature Sensor TS-002",
    toolId: "TL003",
    toolName: "Dry Block Temperature Calibrator TC-003",
    plannedStartDate: "2026-02-10",
    plannedDueDate: "2026-02-11",
    frequency: "semi-annually",
    description:
      "H1 2026 temperature sensor calibration - completed and approved",
    status: "completed",
    priority: "high",
    technician: "Mike Wilson",
    approver: "Emily Davis",
    approvedBy: "Emily Davis",
    approvedAt: "2026-02-12T10:00:00.000Z",
    createdBy: "Admin User",
    createdAt: "2026-01-28T14:00:00.000Z",
    lastModified: "2026-02-12T10:00:00.000Z",
    actualStartDate: "2026-02-10T09:00:00.000Z",
    actualEndDate: "2026-02-11T13:00:00.000Z",
    completedAt: "2026-02-11T13:00:00.000Z",
    result: "PASS",
    certificateNumber: "CAL-2026-0092",
    nextCalibrationDate: "2026-08-10",
    calibrationDate: "2026-02-10",
    calibrationType: "external",
    calibratedBy: "Mike Wilson",
    calibrationNotes:
      "External calibration per IEC 60751. Temperature linearity verified across full range. Sensor response time 4.2s within spec. Certificate issued by accredited lab.",
    measurements: [
      {
        point: "-50°C",
        reference: "-50.00°C",
        measured: "-49.96°C",
        error: "0.04°C",
        tolerance: "±0.3°C",
        result: "PASS",
      },
      {
        point: "0°C",
        reference: "0.00°C",
        measured: "0.02°C",
        error: "-0.02°C",
        tolerance: "±0.3°C",
        result: "PASS",
      },
      {
        point: "100°C",
        reference: "100.00°C",
        measured: "100.05°C",
        error: "-0.05°C",
        tolerance: "±0.3°C",
        result: "PASS",
      },
      {
        point: "200°C",
        reference: "200.00°C",
        measured: "199.97°C",
        error: "0.03°C",
        tolerance: "±0.3°C",
        result: "PASS",
      },
    ],
    certificates: [
      {
        number: "CAL-2026-0092",
        issuedBy: "Accredited Metrology Lab",
        issuedAt: "2026-02-12",
        validUntil: "2026-08-10",
        traceable: "NIST",
      },
    ],
  },
  {
    id: "PMCAL-2026-0010",
    assetId: "AST009",
    assetName: "Dissolved Oxygen Meter DO-009",
    toolId: "TL009",
    toolName: "DO Calibration Standard DS-009",
    plannedStartDate: "2026-05-10",
    plannedDueDate: "2026-05-12",
    frequency: "quarterly",
    description: "Q2 2026 dissolved oxygen meter calibration",
    status: "pending",
    priority: "medium",
    technician: "Carlos Mendez",
    approver: "Maria Rodriguez",
    createdBy: "Admin User",
    createdAt: "2026-04-04T11:00:00.000Z",
    lastModified: "2026-04-04T11:00:00.000Z",
    estimatedDuration: "2 hours",
    requirements: "Zero oxygen solution, air-saturated water standard",
    riskAssessment: "Low risk - monitoring instrument",
  },
  {
    id: "PMCAL-2026-0011",
    assetId: "AST003",
    assetName: "Analytical Balance AB-003",
    toolId: "TL001",
    toolName: "Digital Multimeter DM-001",
    plannedStartDate: "2026-01-20",
    plannedDueDate: "2026-01-22",
    frequency: "quarterly",
    description: "Q1 2026 analytical balance calibration - completed",
    status: "completed",
    priority: "critical",
    technician: "Sarah Johnson",
    approver: "Maria Rodriguez",
    approvedBy: "Maria Rodriguez",
    approvedAt: "2026-01-23T09:00:00.000Z",
    createdBy: "Admin User",
    createdAt: "2026-01-10T08:00:00.000Z",
    lastModified: "2026-01-23T09:00:00.000Z",
    actualStartDate: "2026-01-20T09:00:00.000Z",
    actualEndDate: "2026-01-22T12:00:00.000Z",
    completedAt: "2026-01-22T12:00:00.000Z",
    result: "PASS",
    certificateNumber: "CAL-2026-0076",
    nextCalibrationDate: "2026-04-20",
    calibrationDate: "2026-01-20",
    calibrationType: "internal",
    calibratedBy: "Sarah Johnson",
    calibrationNotes:
      "Analytical balance calibrated per SOP-CAL-010 using NIST-traceable Class E2 weights. Linearity and repeatability checks passed. Eccentricity test performed at all 5 positions.",
    measurements: [
      {
        point: "0 g",
        reference: "0.0000 g",
        measured: "0.0001 g",
        error: "0.0001 g",
        tolerance: "±0.0005 g",
        result: "PASS",
      },
      {
        point: "100 g",
        reference: "100.0000 g",
        measured: "99.9998 g",
        error: "0.0002 g",
        tolerance: "±0.0005 g",
        result: "PASS",
      },
      {
        point: "200 g",
        reference: "200.0000 g",
        measured: "200.0003 g",
        error: "0.0003 g",
        tolerance: "±0.0005 g",
        result: "PASS",
      },
    ],
    certificates: [
      {
        number: "CAL-2026-0076",
        issuedBy: "Internal Calibration Lab",
        issuedAt: "2026-01-23",
        validUntil: "2026-04-20",
        traceable: "NIST Class E2",
      },
    ],
  },
  {
    id: "PMCAL-2026-0012",
    assetId: "AST005",
    assetName: "Viscosity Meter VM-005",
    toolId: "TL006",
    toolName: "Viscosity Reference Standard VS-006",
    plannedStartDate: "2025-10-08",
    plannedDueDate: "2025-10-09",
    frequency: "semi-annually",
    description: "H2 2025 viscosity meter calibration - completed",
    status: "completed",
    priority: "high",
    technician: "Tom Baker",
    approver: "Sarah Johnson",
    approvedBy: "Sarah Johnson",
    approvedAt: "2025-10-10T11:00:00.000Z",
    createdBy: "Admin User",
    createdAt: "2025-09-25T13:00:00.000Z",
    lastModified: "2025-10-10T11:00:00.000Z",
    actualStartDate: "2025-10-08T09:00:00.000Z",
    actualEndDate: "2025-10-09T11:30:00.000Z",
    completedAt: "2025-10-09T11:30:00.000Z",
    result: "PASS",
    certificateNumber: "CAL-2025-0214",
    nextCalibrationDate: "2026-04-14",
    calibrationDate: "2025-10-08",
    calibrationType: "external",
    calibratedBy: "Tom Baker",
    calibrationNotes:
      "External calibration performed using certified Cannon viscosity standards at 25°C. Temperature bath stability ±0.01°C maintained throughout. All test points within manufacturer specification.",
    measurements: [
      {
        point: "10 cP",
        reference: "10.00 cP",
        measured: "10.02 cP",
        error: "0.02 cP",
        tolerance: "±0.10 cP",
        result: "PASS",
      },
      {
        point: "100 cP",
        reference: "100.00 cP",
        measured: "99.97 cP",
        error: "0.03 cP",
        tolerance: "±0.50 cP",
        result: "PASS",
      },
    ],
    certificates: [
      {
        number: "CAL-2025-0214",
        issuedBy: "Accredited Metrology Lab",
        issuedAt: "2025-10-10",
        validUntil: "2026-04-14",
        traceable: "NIST SRM 2490",
      },
    ],
  },
  {
    id: "PMCAL-2026-0013",
    assetId: "AST010",
    assetName: "Spectrophotometer SP-010",
    toolId: "TL004",
    toolName: "UV Wavelength Standard UVS-004",
    plannedStartDate: "2026-02-08",
    plannedDueDate: "2026-02-10",
    frequency: "semi-annually",
    description:
      "H1 2026 spectrophotometer wavelength & absorbance calibration - completed",
    status: "completed",
    priority: "high",
    technician: "Maria Rodriguez",
    approver: "Thomas Anderson",
    approvedBy: "Thomas Anderson",
    approvedAt: "2026-02-11T14:00:00.000Z",
    createdBy: "Admin User",
    createdAt: "2026-01-28T10:00:00.000Z",
    lastModified: "2026-02-11T14:00:00.000Z",
    actualStartDate: "2026-02-08T09:00:00.000Z",
    actualEndDate: "2026-02-10T13:00:00.000Z",
    completedAt: "2026-02-10T13:00:00.000Z",
    result: "PASS",
    certificateNumber: "CAL-2026-0089",
    nextCalibrationDate: "2026-08-08",
    calibrationDate: "2026-02-08",
    calibrationType: "external",
    calibratedBy: "Maria Rodriguez",
    calibrationNotes:
      "Wavelength calibration performed using NIST SRM 2035a holmium oxide standard. Photometric accuracy verified with NIST SRM 930e neutral density filters. All parameters meet ISO/IEC 17025 requirements.",
    measurements: [
      {
        point: "360 nm",
        reference: "360.0 nm",
        measured: "360.1 nm",
        error: "0.1 nm",
        tolerance: "±0.3 nm",
        result: "PASS",
      },
      {
        point: "486 nm",
        reference: "486.0 nm",
        measured: "486.0 nm",
        error: "0.0 nm",
        tolerance: "±0.3 nm",
        result: "PASS",
      },
      {
        point: "637 nm",
        reference: "637.0 nm",
        measured: "637.2 nm",
        error: "0.2 nm",
        tolerance: "±0.3 nm",
        result: "PASS",
      },
    ],
    certificates: [
      {
        number: "CAL-2026-0089",
        issuedBy: "ISO/IEC 17025 Accredited Lab",
        issuedAt: "2026-02-11",
        validUntil: "2026-08-08",
        traceable: "NIST SRM 2035a",
      },
    ],
  },
];

// Attach EAM integration fields and convenience aliases
export const samplePMCals = basePMCals.map((pmCal, idx) => ({
  ...pmCal,
  startDate: pmCal.plannedStartDate,
  dueDate: pmCal.plannedDueDate,
  source: "Oriens EAM",
  eamWorkOrderNo: eamWorkOrders[idx],
  eamPMPlanId: eamPMPlans[idx],
  eamPushedAt: pmCal.createdAt,
}));

// Status badge helper
export function getStatusBadgeClass(status) {
  const map = {
    pending: "badge-pending",
    "in-progress": "badge-in-progress",
    completed: "badge-completed",
    overdue: "badge-overdue",
    rejected: "badge-rejected",
    approved: "badge-approved",
  };
  return map[status] || "badge-secondary";
}

export function getStatusLabel(status) {
  const map = {
    pending: "Pending",
    "in-progress": "In Progress",
    completed: "Completed",
    overdue: "Overdue",
    rejected: "Rejected",
    approved: "Approved",
  };
  return map[status] || status || "Unknown";
}
